module.exports = __webpack_public_path__ + "static/img/Boss_31089.7697ed8e.png";